import React from 'react';
import ControllerTesterWithSiteConfig from '../component/controller-tester-with-site-config';

const ControllerTesterPage = (props) => {
    if (props.siteId == null) {
        return <div>Select a site</div>;
    }
    if (props.siteConfig.status !== 200) {
        return <div>Failed to load site configuration for {props.siteId}. Please contact SBL tech team.</div>;
    }
    return <ControllerTesterWithSiteConfig {...props}/>;
};

export default ControllerTesterPage;



// WEBPACK FOOTER //
// ./src/components/devicemanagement/ledcontroller/bintester/view/controller-tester-page.jsx